// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useMemo, useState } from 'react';
import { BrokerageConfig, Charge } from './type';
import { InstrumentType } from 'v3/common/types/type';
import { getSegmentCharges } from './helper';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap-old';
import { Currency } from 'v3/common/constants/currency';
import { BrokerageChargeType, croreLabel, TransactionChargeLabels } from 'v3/common/constants/brokerage';

const ChargeRow = ({
  charge,
  productType,
  transactionType,
  chargeType,
}: {
  charge: Charge;
  productType: string;
  transactionType?: string;
  chargeType: string;
}) => {
  const finalPrice = charge.maxCap ? Math.min(charge.price, charge.maxCap) : charge.price;
  const priceFormat =
    chargeType === BrokerageChargeType.NSEIPFT || chargeType === BrokerageChargeType.SEBI
      ? `${finalPrice} ( ${croreLabel} )`
      : finalPrice;

  return (
    <div className="mb-2 tx-14" key={`${productType}-${transactionType || ''}`}>
      <div className="broker-charges-title">
        <span>
          {productType === 'ALL' ? 'BUY & SELL' : productType} {transactionType && `( ${transactionType} )`}
        </span>
      </div>

      <div className="broker-charges-sec">
        <span>
          {charge.isPercentage ? (
            `${finalPrice}%`
          ) : (
            <span>
              {Currency.INR} {priceFormat}
            </span>
          )}
        </span>
        {charge.maxCap && (
          <span>
            (or) {Currency.INR} {charge.maxCap} whichever is lower
          </span>
        )}
      </div>
    </div>
  );
};

export const RenderBrokerage = ({
  availableBrokerageSegments,
  brokerageConfig,
}: {
  availableBrokerageSegments: InstrumentType[];
  brokerageConfig: BrokerageConfig;
}) => {
  const [selectedSegment, setSelectedSegment] = useState(availableBrokerageSegments[0]);

  const chargesForSegments = useMemo(
    () => getSegmentCharges(availableBrokerageSegments, brokerageConfig),
    [availableBrokerageSegments, brokerageConfig]
  );

  const current = chargesForSegments.find((c) => c.segment === selectedSegment);

  return (
    <div className="render-brokerage-container">
      <ToggleButtonGroup
        type="radio"
        name="segmentOptions"
        bsPrefix="btn-group btn-group-toggle"
        value={selectedSegment}
        onChange={(value) => setSelectedSegment(value)}
      >
        {availableBrokerageSegments.map((segment) => (
          <ToggleButton key={segment} value={segment} bsPrefix="btn btn-outline-primary btn-lightness btn-sm">
            {segment}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {current && (
        <div className="mt-3">
          <div className="row brokerage-row">
            {Object.entries(current.charges).map(([chargeType, chargeData]) => (
              <div key={chargeType} className="col-lg-6 brokerage-col">
                <div className="card brokerage-card">
                  <h6>{TransactionChargeLabels[chargeType]}</h6>

                  {chargeData.map(({ productType, transactionType, charge }) => (
                    <ChargeRow
                      key={`${productType}-${transactionType}`}
                      charge={charge}
                      productType={productType}
                      transactionType={transactionType}
                      chargeType={chargeType}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
